import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import OpenSourcingStatement from "@/components/OpenSourcingStatement";
import { focusAreas } from "@/data/focusAreas";

export default function FocusAreasPage({ onEnquiry }) {
  return (
    <main data-testid="focus-areas-page">
      <PageHero eyebrow="Current Focus Areas" title="A starting point, not a limit." description="UGI is open to sourcing across products and sectors based on international buyer requirements. These are the areas currently being focused on." testId="focus-areas-page-hero" />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {focusAreas.map((area, index) => (
            <Link key={area.slug} data-testid={`focus-area-page-card-${area.slug}`} to={`/focus-areas/${area.slug}`} className={`group overflow-hidden border border-[#E5DFD3] bg-[#F5F2EB] shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${index === 0 ? "md:col-span-2" : ""}`}>
              <div className={index === 0 ? "aspect-[16/8] overflow-hidden" : "aspect-[16/10] overflow-hidden"}>
                <img src={area.image} alt={area.alt} loading="eager" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.035]" />
              </div>
              <div className="p-7">
                <div className="flex items-center justify-between gap-4">
                  <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#C5A059]">Current Focus</p>
                  <ArrowUpRight size={17} strokeWidth={1.5} className="text-[#9B7437] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </div>
                <h2 className="mt-4 font-serif text-3xl font-normal text-[#1C1613]">{area.title}</h2>
                <p className="mt-4 text-sm leading-7 text-[#524842]">{area.summary}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <OpenSourcingStatement onEnquiry={onEnquiry} />
    </main>
  );
}
